import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store/store";
import App from "./App";
import { installViewerMocks } from "./pages/viewer/mocks/installMocks";
import "./assets/scss/dashlite.scss";
import "./assets/scss/style-email.scss";
import "./App.css";

// Viewer mock layer — no-op unless REACT_APP_VIEWER_MOCK=true.
installViewerMocks();

const rootElement = document.getElementById("root") as HTMLElement;
const root = ReactDOM.createRoot(rootElement);

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
);
